import type { AssetTechnicalUpdateProps } from "./asset-technical-update.type";

import { Card } from "antd";

import { AssetTechnicalForm } from "@/modules/asset/asset-technical-form";
import AssetTechnicalSaveBar from "@/modules/asset/asset-technical-save-bar";
import AssetTechnicalUpdateHistory from "@/modules/asset/asset-technical-update-history";

import { useAssetTechnicalDataUpdate } from "./asset-technical-update.hook";

const AssetTechnicalUpdate = ({ asset }: AssetTechnicalUpdateProps) => {
  const {
    onSave,
    onCancel,
    handleDataChange,
    schema,
    isLoading,
    form,
    lastTechnicalUpdate,
  } = useAssetTechnicalDataUpdate(asset);

  return (
    <>
      <AssetTechnicalSaveBar
        asset={asset}
        onCancel={onCancel}
        onSave={onSave}
        loading={isLoading}
      />
      <Card
        loading={isLoading}
        title={
          lastTechnicalUpdate && (
            <AssetTechnicalUpdateHistory
              lastTechnicalUpdate={lastTechnicalUpdate}
            />
          )
        }
      >
        <AssetTechnicalForm
          schema={schema}
          handleChange={handleDataChange}
          form={form}
        />
      </Card>
    </>
  );
};

export default AssetTechnicalUpdate;
